import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class EmployeePlatformUsage extends DomainObject {
  reviewsCount;
  trainingsCount;
  timeOffRequestsCount;
  hiringCollaboratorsCount;
  directReportsCount;
  enrolledInTimeOff;
  enrolledInBenefits;
  enrolledInPayroll;

  constructor(other) {
    super();

    makeObservable(this, {
      reviewsCount: observable,
      trainingsCount: observable,
      timeOffRequestsCount: observable,
      hiringCollaboratorsCount: observable,
      directReportsCount: observable,
      enrolledInTimeOff: observable,
      enrolledInBenefits: observable,
      enrolledInPayroll: observable
    });

    this.merge(other);
  }
}

export default EmployeePlatformUsage;
